import { render, staticRenderFns } from "./editar.vue?vue&type=template&id=5257a082&scoped=true&"
import script from "./editar.vue?vue&type=script&lang=ts&"
export * from "./editar.vue?vue&type=script&lang=ts&"
import style0 from "./editar.vue?vue&type=style&index=0&id=5257a082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257a082",
  null
  
)

export default component.exports